import { render, staticRenderFns } from "./WsStatusIndicator.vue?vue&type=template&id=65045137&scoped=true&"
import script from "./WsStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./WsStatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./WsStatusIndicator.vue?vue&type=style&index=0&id=65045137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65045137",
  null
  
)

export default component.exports